export const SIGNATURE_MISSING_TIP = 'Signature missing/expired, please log in again.';

export const MAX_UPDATE_TIME = 15;

export const GOT_IT = 'Got it';

export const MIN_AMOUNT_DISPLAY = '0.0001';

export const MIN_AMOUNT_USD_DISPLAY = '0.01';

export const ETRANSFER_LOGO = 'https://cms.etransfer.exchange/assets/b4f969c7-bdcd-4676-9df8-a3350ae26dd2';

export const LOGIN = 'Log In';

export const COBO_CUSTODY = 'Cobo Custody';

export const NOTICE = 'Notice';
